import { CreateBankAccountFormData } from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import { EditBankAccountFormData } from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import { EditBankAccountInputData } from '@/features/dashboard/paymentConfig/schemas/bankAccountSchema.ts';
import {
  BankAccountDto,
  CreateBankAccountRequest,
  UpdateBankAccountRequest,
} from '@/features/dashboard/paymentConfig/types/BankAccountDto.ts';
import {
  toElectronicFormat,
  toDisplayFormat,
} from '@/features/dashboard/paymentConfig/types/BankAccountDto.utils.ts';

export const bankAccountMapper = {
  fromCreateFormToDto(
    form: CreateBankAccountFormData,
  ): CreateBankAccountRequest {
    return {
      ...form,
      accountNumber: toElectronicFormat(form.accountNumber, form.accountType),
    };
  },
  fromEditFormToDto(form: EditBankAccountFormData): UpdateBankAccountRequest {
    return {
      ...form,
      accountNumber: toElectronicFormat(form.accountNumber, form.accountType),
    };
  },
  fromDtoToEditForm(dto: BankAccountDto): EditBankAccountInputData {
    return {
      accountType: dto.accountType,
      bankName: dto.bankName,
      accountNumber: toDisplayFormat(dto.accountNumber, dto.accountType),
      companyAddress: dto.companyAddress ?? '',
      swiftCode: dto.swiftCode ?? '',
    };
  },
};
